<div class="errwrap">
  <div class="errdiv1" id="errs"></div>
</div>

<div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title">{{ screentitle }}</h1>

      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="btn back-button button-margin ">
          <!-- //****************** -->

          <button [disabled]="RAC_APROVE != 1" class="approved"
            *ngIf="isApproved && actionmode == 'Edit' && rejected!=2">
            <span class="bold">Approved</span>
          </button>
          <input type="button" [disabled]="RAC_APROVE != 1" class="btn btn-success commonbutt zol" value="Active"
            id="btnname" (click)="changeName()" *ngIf="isApproved && actionmode == 'Edit' && rejected!=2" />
          <!-- //****************** -->

          <button [disabled]="
              showList == true ||
              viewpage == true ||
              minPValueNotNumeric ||
              notValidMinPercentage ||
              maxPValueNotNumeric ||
              notValidMaxPercentage ||
              tmPValueNotNumeric ||
              notValidTMPercentage ||
              pomrPValueNotNumeric ||
              notValidpomrPercentage ||
              tmfValueNotNumeric ||
              startValueFlag ||
              endValueFlag ||
              endDateInvalid
            " class="btn btn-success commonbutt" type="button" (click)="submitdata()">
            <em class="fa fa-check"></em>&nbsp;Submit
          </button>
          <button [disabled]="
              minPValueNotNumeric ||
              notValidMinPercentage ||
              maxPValueNotNumeric ||
              notValidMaxPercentage ||
              tmPValueNotNumeric ||
              notValidTMPercentage ||
              pomrPValueNotNumeric ||
              notValidpomrPercentage ||
              tmfValueNotNumeric ||
              startValueFlag ||
              endValueFlag ||
              endDateInvalid
            " class="btn btn-success commonbutt" type="button"
            *ngIf="!isApproved && updateApprove && RAC_APROVE == '1'" data-toggle="modal" data-target="#myModal">
            <em class="fa fa-thumbs-up "></em>&nbsp;&nbsp;
            <span class="bold">Approve</span>
          </button>
          <button [disabled]="
              minPValueNotNumeric ||
              notValidMinPercentage ||
              maxPValueNotNumeric ||
              notValidMaxPercentage ||
              tmPValueNotNumeric ||
              notValidTMPercentage ||
              pomrPValueNotNumeric ||
              notValidpomrPercentage ||
              tmfValueNotNumeric ||
              startValueFlag ||
              endValueFlag ||
              endDateInvalid
            " class="btn btn-warning commonbutt" type="button"
            *ngIf="!isApproved && updateApprove && RAC_APROVE == '1'" data-toggle="modal" data-target="#myModal2">
            <em class="fa fa-thumbs-down"></em> <span class="bold">Reject</span>
          </button>

          <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div>
                  <div>
                    <div>
                      <div class="errwrap">
                        <div class="errdiv1" id="err"></div>
                      </div>
                      <div class="col-lg-4">
                        <label>Select Journey Class</label>
                        <select class="form-control" [(ngModel)]="screenDetails.JOURNEY_ID"
                          (change)="getFareProduct(); gotochangestatus()"
                          [disabled]="showList == true || actionmode == 'Edit'">
                          <option disabled value="">Select Journey Class</option>
                          <option value="{{ combo.JOURNEY_ID }}" *ngFor="let combo of combo_details1">{{
                            combo.JOURNEY_NAME }}</option>
                        </select>
                      </div>
                      <div class="col-lg-4">
                        <label>Fare Product</label>
                        <select class="form-control" [(ngModel)]="screenDetails.FARE_PRODUCT_LABEL"
                          (change)="gotochangestatus()" [disabled]="notSelectJC || actionmode == 'Edit'">
                          <option value="">Select Fare Product</option>
                          <option *ngFor="let fareProductLabel of fareProductLabels" value="{{ fareProductLabel.key }}">
                            {{ fareProductLabel.value }}</option>
                        </select>
                      </div>
                      <div class="col-lg-4">
                        <label>Description</label>
                        <input [(ngModel)]="screenDetails.DESCRIPTION" type="text" [disabled]="showList == true"
                          (input)="gotochangestatus()" (change)="gotochangestatus()" class="form-control"
                          placeholder="Enter Description" />
                      </div>
                      <div class="clr"></div>
                      <div class="divider"></div>
                      <div class="col-lg-4">
                        <label>Min Range%</label>
                        <input [(ngModel)]="screenDetails.MIN_RANGE_PERCENTAGE" type="text" class="form-control"
                          [disabled]="showList == true" placeholder="Enter Min Range%" id="price_range_start"
                          (change)="gotochangestatus()" #price_range_start="ngModel" name="price_range_start" value=""
                          maxlength="10" (input)="checkMinValuePerc($event.target.value)" />
                        <span class="errmsg" id="pstart" style="color: red"></span>
                        <span *ngIf="minPValueNotNumeric" style="color: red">Accepts numeric values only.</span>
                        <span *ngIf="notValidMinPercentage" style="color: red">percentage must be between 0 to
                          100.</span>
                      </div>
                      <div class="col-lg-4">
                        <label>Max Range%</label>
                        <input [(ngModel)]="screenDetails.MAX_RANGE_PERCENTAGE" type="text" class="form-control"
                          placeholder="Enter Max Range%" [disabled]="showList == true" id="price_range_end"
                          #price_range_end="ngModel" name="price_range_end" value="" maxlength="10"
                          (change)="checkPriceEnd(); gotochangestatus()"
                          (input)="checkMaxValuePerc($event.target.value)" />
                        <span class="errmsg" id="pend" style="color: red"></span>
                        <span *ngIf="maxPValueNotNumeric" style="color: red">Accepts numeric values only.</span>
                        <span *ngIf="notValidMaxPercentage" style="color: red">percentage must be between 0 to
                          100.</span>
                      </div>
                      <div class="col-lg-4">
                        <label>Threshold Miles Fixed</label>
                        <input [(ngModel)]="screenDetails.THRESHOLD_MILES" type="text"
                          [disabled]="showList == true || thresholdMiles" class="form-control"
                          placeholder="Threshold Miles" id="THRESHOLD_MILES" #THRESHOLD_MILES="ngModel"
                          name="THRESHOLD_MILES" value="" (input)="checkThresholdMiles($event.target.value)"
                          (change)="gotochangestatus()" />
                        <span *ngIf="tmfValueNotNumeric" style="color: red">Accepts Numeric values only.</span>
                      </div>

                      <div class="clr"></div>
                      <div class="divider"></div>
                      <div class="col-lg-4">
                        <mat-form-field>
                          <input matInput [(ngModel)]="screenDetails.APPLICABLE_FROM" [min]="newDate"
                            [matDatepicker]="pickerFrom" (dateChange)="checkStartDate($event)"
                            (focus)="pickerFrom.open()" (click)="pickerFrom.open()" autocomplete="off"
                            placeholder="Valid From" readonly />
                          <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                          <mat-datepicker #pickerFrom></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div class="col-lg-4">
                        <mat-form-field>
                          <input matInput [(ngModel)]="screenDetails.APPLICABLE_TO"
                            [min]="screenDetails.APPLICABLE_FROM" [matDatepicker]="pickerTo"
                            (dateChange)="checkEndDate($event)" (focus)="pickerTo.open()" (click)="pickerTo.open()"
                            autocomplete="off" placeholder="Valid Till" readonly />
                          <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                          <mat-datepicker #pickerTo></mat-datepicker>
                        </mat-form-field>
                        <br>
                        <span *ngIf="endDateInvalid" style="color: red;font-size: 10px"> 'To' date should be greater
                          than 'Form' date </span>
                      </div>
                      <div class="col-lg-4">
                        <label>Percentage of Max Range</label>
                        <input [(ngModel)]="screenDetails.PERCENTAGE_OF_MAX_RANGE" type="text"
                          [disabled]="showList == true" class="form-control" placeholder="Enter Percentage of Max Range"
                          maxlength="10" id="PERCENTAGE_OF_MAX_RANGE" #PERCENTAGE_OF_MAX_RANGE="ngModel"
                          name="PERCENTAGE_OF_MAX_RANGE" value="" (change)="gotochangestatus()"
                          (input)="checkPOMRValuePerc($event.target.value)" />
                        <span *ngIf="pomrPValueNotNumeric" style="color: red">Accepts numeric values only.</span>
                        <span *ngIf="notValidpomrPercentage" style="color: red">percentage must be between 0 to
                          100.</span>
                      </div>

                      <div class="clr"></div>
                      <div class="divider"></div>
                      <div class="col-lg-4">
                        <label>Round Off</label>
                        <select class="form-control" [(ngModel)]="screenDetails.ROUNDUP" (change)="gotochangestatus()">
                          <option value="">Select Round Off</option>
                          <option *ngFor="let roundUpValue of roundUpValues" value="{{ roundUpValue }}">
                            {{ roundUpValue }}
                          </option>
                        </select>
                      </div>
                      <div class="clr"></div>
                      <div class="divider"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ########## -->
<div class="modal fade" id="myModal" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 31px;">
        <button type="button" (click)="clearRemark()" class="close" data-dismiss="modal">
          &times;
        </button>
        <h4 class="modal-title">
          <span class="glyphicon glyphicon-thumbs-up" style="margin-right: 10px"></span>Do you want to approve ?
        </h4>
      </div>

      <div class="modal-body">
        <div class="col-lg-13">
          <label> Remarks</label>
          <textarea
           (input)="getremark($event.target.value)"
           [(ngModel)]="aprove_details.APPROVAL_REMARKS"
            (blur)="checkRemarkLength($event.target.value)" 
            rows="8" cols="20" type="text" class="form-control m-input" placeholder="Enter  Remarks">
          </textarea>
          <span *ngIf="minRemark" 
          class="m-form__help" style="color: red">Please enter Remarks with minimum length
            3</span>
        </div>
      </div>
      <div class="modal-footer">
        <button 
         [disabled]="!aprvbtn" 
        class="btn btn-success " type="button" (click)="aproveReject(1)"
          data-dismiss="modal">
          <span class="bold">Yes</span>
        </button>

        <button class="btn btn-warning " 
        (click)="clearRemark()" type="button" 
        data-dismiss="modal">
          <span class="bold">No</span>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- ########## -->

<!-- ########## -->
<div class="modal fade" id="myModal2" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 31px;">
        <button type="button" class="close" 
        (click)="clearRemark()" 
        data-dismiss="modal">
          &times;
        </button>
        <h4 class="modal-title">
          <span 
          class="glyphicon glyphicon-thumbs-down" 
          style="margin-right: 10px"></span>Do you want to reject ?
        </h4>
      </div>
      <div class="modal-body">
        <div class="col-lg-13">
          <label>Remarks</label>
          <textarea  (blur)="checkRemarkLength($event.target.value)"
          [(ngModel)]="aprove_details.APPROVAL_REMARKS" rows="8"
           (input)="getremark($event.target.value)"
            cols="20" type="text" class="form-control m-input"
            placeholder="Enter  Remarks">
          </textarea>
          <span *ngIf="minRemark"  style="color: red"
          class="m-form__help">Please enter Remarks with minimum length
            3</span>
        </div>
      </div>
      <div class="modal-footer">
        <button 
        class="btn btn-success" type="button" (
          click)="aproveReject(2)"
          [disabled]="!aprvbtn" 
          data-dismiss="modal">
          <span class="bold">Yes</span>
        </button>
        <button 
        class="btn btn-warning " 
        (click)="clearRemark()" 
        type="button" data-dismiss="modal">
          <span class="bold">No</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ########## remarks modal ends-->



<div *ngIf="actionmode != 'Add' && 
      actionmode != 'Edit' && 
      actionmode != 'View'" class="searchdiv">
  <div class="headerdiv">
    <h1>Fare Product Search</h1>
    <div class="bothbuttdiv">
      <button class="btn btn-primary commonbutt" type="button" *ngIf="RAC_ADD == '1'" (click)="addForm()">
        <em class="fa fa-plus-circle"></em>&nbsp;Add New
      </button>

    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div class="row">
            <div class="m-portlet">
              <div style="padding: 2% 2% 2% 2%">
                <div>
                  <div class="wr15">



                    <div class="instruct">
                      <div class="int1" style="margin-left: 17px">
                        <span class="inst" style="font-size: 12px"><strong> Instructions </strong></span>
                        <br />


                        <span class="txt">
                          1. Select at least one value out of Journey Class,Fare Product

                        </span>
                        <br />
                        <span class="txt">
                          2. You can also use a combination of the given fields to search </span>
                        <br />
                        <span></span>
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <label>Journey Class</label>
                      <select class="form-control" (change)="getName()" [(ngModel)]="search_details.JOURNEY_NAME">
                        <option value="">Select Journey Class</option>
                        <option *ngFor="let JournyClass of JournyClasses" value="{{ JournyClass }}">
                          {{ JournyClass }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-4">
                      <label>Fare Product</label>
                      <select class="form-control" [(ngModel)]="search_details.FARE_PRODUCT_LABEL">
                        <option value="">Select Fare Product</option>
                        <option *ngFor="let searchFPLabel of searchFPLabels" value="{{ searchFPLabel.key }}">{{
                          searchFPLabel.value }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="btn clear-button button-margin">
                  <button class="btn btn-primary commonbutt" style="margin-top:21px" (click)="searchData()"
                    type="button">
                    <em class="fa fa-search "></em>&nbsp;Search
                  </button>


                  <button class="btn btn-success commonbutt" style="margin-top:21px" [disabled]="disabledown"
                    (click)="downloadFile()" type="button">
                    Download
                  </button>

                </div>
              </div>

              <div class="errwrap">
                <div class="errdiv1" id="err"></div>
              </div>

              <div *ngIf="searchresult" class="reportstatus" [hidden]="searchlist">
                <table aria-describedby="fpDetails" class="table table-striped" [mfData]="serachtabledata"
                  [mfRowsOnPage]="5">
                  <thead>
                    <tr>
                      <th scope="col" style="width: 12%" *ngIf="RAC_VIEW == '1' && RAC_EDIT == '1'">
                        Actions
                      </th>
                      <th style="width: 20%" scope="col">
                        <mfDefaultSorter by="JOURNEY_NAME">Journy Class
                        </mfDefaultSorter>
                      </th>
                      <th style="width: 20%" scope="col">
                        <mfDefaultSorter by="JOURNEY_NAME">Fare Product
                        </mfDefaultSorter>
                      </th>
                      <th style="width: 20%" scope="col">
                        <mfDefaultSorter by="JOURNEY_NAME">Start Date
                        </mfDefaultSorter>
                      </th>
                      <th style="width: 18%" scope="col">
                        <mfDefaultSorter by="JOURNEY_NAME">End Date
                        </mfDefaultSorter>
                      </th>
                      <th style="width: 20%" scope="col">
                        <mfDefaultSorter by="JOURNEY_NAME">Status</mfDefaultSorter>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="
                        let item of (serachtabledata
                          | paginate: { itemsPerPage: 10, currentPage: p })
                      ">
                      <td *ngIf="RAC_VIEW == '1' && RAC_EDIT == '1'">
                        <button class="btn btn-default btn-circle" *ngIf="RAC_VIEW == '1'" type="button"
                          (click)="showFormData(item.FARE_PRODUCT_ID, 1, 1, 1)">
                          <em class="fa fa-eye"></em>
                        </button>
                        <span *ngIf="item.STATUS != '2' && item.PRE_APPROVE != '1'">
                          <button class="btn btn-default btn-circle" *ngIf="RAC_EDIT == '1'" type="button" (click)="
                              showFormData(
                                item.FARE_PRODUCT_ID,
                                2,
                                item.STATUS,
                                item.APPROVAL_STATUS
                              )
                            ">
                            <em class="fa fa-pencil"></em>
                          </button>
                        </span>
                      </td>
                      <td>{{ item.JOURNEY_NAME }}</td>
                      <td *ngIf="item.FARE_PRODUCT_LABEL == 'ECOFP1'">
                        Economy
                      </td>
                      <td *ngIf="item.FARE_PRODUCT_LABEL == 'ECOFP2'">
                        Economy Plus
                      </td>
                      <td *ngIf="item.FARE_PRODUCT_LABEL == 'ECOFP3'">
                        Economy pro
                      </td>
                      <td *ngIf="item.FARE_PRODUCT_LABEL == 'BUSFP1'">
                        Premium
                      </td>
                      <td>{{ item.APPLICABLE_FROM }}</td>
                      <td>{{ item.APPLICABLE_TO }}</td>
                      <td>
                        <div *ngIf="item.APPROVAL_STATUS == 0 &&
                            item.STATUS == 0 &&
                            item.PRE_APPROVE != 1">
                          <span class="icls1">
                            <button class="btn commonbutt zol1">Inactive</button>
                            <span class="tooltiptext">Not Approved</span>
                          </span>
                        </div>

                        <div *ngIf="item.APPROVAL_STATUS == 1 && 
                        item.PRE_APPROVE != 1">
                          <span class="icls1">
                            <button class="btn  commonbutt zol" 
                            *ngIf="item.STATUS == 1">
                              Active
                            </button>

                            <button class="btn  commonbutt zol1" 
                            *ngIf="item.STATUS == 0">
                              Inactive
                            </button>

                            <span class="tooltiptext"> Approved </span>

                          </span>
                        </div>

                        <div *ngIf="item.APPROVAL_STATUS == 0 && 
                              item.PRE_APPROVE == 1">
                          <span class="icls1">
                            <button class="btn  commonbutt zol">
                              Active
                            </button>
                            <span class="tooltiptext"> Approved </span>

                          </span>
                        </div>


                        <div *ngIf="item.APPROVAL_STATUS == 2 && 
                              item.STATUS == 2">
                          <span class="icls5">
                            <button class="btn  commonbutt zol1">
                              Inactive
                            </button>

                            <span class="tooltiptext">Rejected</span>
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="6"><pagination-controls (pageChange)="p = $event"></pagination-controls></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div *ngIf="loader">
                <div style="margin:auto; text-align: center">
                  <img
                    src="https://vignette.wikia.nocookie.net/lego/images/b/b4/Loading_Animation.gif/revision/latest/scale-to-width-down/480?cb=20120528032206"
                    width="8%" height="8%" alt="Loader" />
                </div>
              </div>
              <!-- loader ends here  -->
            </div>
          </div>
        </div>
        <!-- form ends here fare  -->
      </div>
    </div>
  </div>
</div>

<div 
  *ngIf="actionmode == 'View'" 
  class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title" 
      *ngIf="showList == !false">{{ viewTitle }}</h1>
      <h1 class="screen-title" 
      *ngIf="showList == false">
        {{ insertDataTitle }}
      </h1>
      <div class="button-wrapper bothbuttdiv2">
        <div 
        *ngIf="actionmode == 'View'" 
        class="btn back-button button-margin ">
          <button class="btn btn-danger commonbutt" 
          (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <!-- form starts here  -->
          <div class="form-div">
            <div class="row">
              <!-- m-portlet starts here  -->
              <div class="m-portlet">
                <div>
                  <div>
                    <div>
                      <div style="padding: 2% 2% 2% 2%">
                        <table aria-describedby="fpCardDetails" class="table table-striped" [mfData]="serachtabledata"
                          [mfRowsOnPage]="5" style="width: 400px">
                          <thead>
                            <tr>
                              <th scope="col"></th>
                            </tr>
                          </thead>
                          <tr>
                            <td><strong>JOURNEY CLASS</strong></td>
                            <td>{{ journeyName }}</td>
                          </tr>
                          <tbody *ngFor="let itemfound of serachTableInfo">
                            <tr>
                              <td><strong>FARE PRODUCT</strong></td>
                              <td>{{ itemfound.FARE_PRODUCT_LABEL }}</td>
                            </tr>
                            <tr>
                              <td><strong>DESCRIPTION</strong></td>
                              <td>{{ itemfound.DESCRIPTION }}</td>
                            </tr>
                            <tr>
                              <td><strong>MIN RANGE%</strong></td>
                              <td>{{ itemfound.MIN_RANGE_PERCENTAGE }}</td>
                            </tr>
                            <tr>
                              <td><strong>MAX RANGE%</strong></td>
                              <td>{{ itemfound.MAX_RANGE_PERCENTAGE }}</td>
                            </tr>
                            <tr>
                              <td><strong>THRESHOLD MILES</strong></td>
                              <td>
                                <div *ngIf="itemfound.FIXED_OR_PERCENTAGE == 1">
                                  {{ itemfound.THRESHOLD }}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td><strong>APPLICABLE FROM</strong></td>
                              <td>{{ itemfound.APPLICABLE_FROM }}</td>
                            </tr>
                            <tr>
                              <td><strong>APPLICABLE TO</strong></td>
                              <td>{{ itemfound.APPLICABLE_TO }}</td>
                            </tr>
                            <tr>
                              <td><strong>PERCENTAGE OF MAX RANGE</strong></td>
                              <td>{{ itemfound.PERCENTAGE_OF_MAX_RANGE }}</td>
                            </tr>
                            <tr>
                              <td><strong>ROUNDUP</strong></td>
                              <td>{{ itemfound.ROUNDUP }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>